import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';
import { authActions } from './authSlice';
import {
  deleteOrder,
  draftOrder,
  getDraft,
  getDraftOrdersByPage,
} from '../../ApiServices/DraftOrderServices';
import { t } from 'i18next';
import { handleResponse } from '../../ApiServices/ApiHandler';

export const initialState = {
  value: { totalCount: -1, data: [] as any[] },
  loading: false,
  error: null,
  rowsPerPage: 10,
  pageNo: 0,
  selectedValue: null,
  sortBy: '',
  sortDirection: 0,
};

const draftordersSlice = createSlice({
  name: 'draftorder',
  initialState: initialState,
  reducers: {
    clearDraftOrdersState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchdraftOrders.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
      state.sortBy = action?.meta?.arg?.sortBy;
      state.sortDirection = action?.meta?.arg?.sortDirection;
    });
    builder.addCase(fetchdraftOrders.rejected, (state: any, action: any) => {
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.error = action?.payload;
    });
    builder.addCase(
      fetchDraftOrderById.fulfilled,
      (state: any, action: any) => {
        state.error = initialState.error;
        state.loading = initialState.loading;
        state.selectedValue = action?.payload?.data;
      }
    );
    builder.addCase(fetchDraftOrderById.rejected, (state: any, action: any) => {
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.error = action?.payload;
    });

    builder.addCase(
      deleteDraftOrderById.fulfilled,
      (state: any, action: any) => {
        state.error = initialState.error;
        state.loading = initialState.loading;
        state.selectedValue = action?.payload?.data;
      }
    );
    builder.addCase(
      deleteDraftOrderById.rejected,
      (state: any, action: any) => {
        state.loading = initialState.loading;
        state.selectedValue = initialState.selectedValue;
        state.error = action?.payload;
      }
    );
  },
});

export const draftOrderState = (state: RootState) => state?.draftorder;
export const { clearDraftOrdersState } = draftordersSlice.actions;
export default draftordersSlice.reducer;

export const fetchdraftOrders = createAsyncThunk(
  'draftorder/fetchdraftOrders',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_CREATE_ORDERS') }));
      return fulfillWithValue(await getDraftOrdersByPage(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const draftorders = createAsyncThunk(
  'draftorder/draftorders',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('ADDING_PRODUCTS_TO_THE_DRAFT') }));
      let response: any = await draftOrder(payload);
      if (response?.status === 200 || response === 200) {
        dispatch(showSuccessSnackbar({ message: t('ORDER_CREATED_IN_CART') }));
        return fulfillWithValue(response);
      } else {
        dispatch(
          showErrorSnackbar({ message: t('ORDER_CREATION_IN_CART_FAILED') })
        );
        return rejectWithValue(response);
      }
      //return await handleResponse(response, fulfillWithValue, rejectWithValue, dispatch);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const fetchDraftOrderById = createAsyncThunk(
  'draftorder/fetchDraftOrderById',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_DRAFT_ORDER') }));
      return fulfillWithValue(await getDraft(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const deleteDraftOrderById = createAsyncThunk(
  'draftorder/deleteDraftOrderById',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('DELETE_ORDER') }));
      // return fulfillWithValue(await deleteOrder(payload));
      let response = await deleteOrder(payload);
      return await handleResponse(
        response,
        fulfillWithValue,
        rejectWithValue,
        dispatch
      );
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
